export class PassengerFormModel {
    firstName: string;
    surname: string;
    gender: string;
    country: string;
    email: string;
    phone: string;
    concessionCard1: string;
    concessionCard2: string;
    concessionLater: boolean;
    concessionCount: number;
    state: string;
    postcode: string;
    males: number;
    females: number;
    studentCard1: string;
    studentCard2: string;
    studentLater: boolean;
    studentCount: number;
    requiresVisa: boolean;
    visaNumber: string;
    visaPromoCode: string;
    constructor() {
        this.gender = '';
        this.country = '';
    }
}
export class Passengers {
    adults: number;
    infants: number;
    nursedInfant: number;
    seatedInfant: number;
    requiresSpecialAssistance: boolean;
    specialAssistanceType: number;
    accompaniedChildren: number;
    concessionCard1: string;
    concessionCard2: string;
    concessionLater: boolean;
    studentCard1: string;
    studentCard2: string;
    studentLater: boolean;
    concessions: number;
    students: number;
    gender: string;
    constructor(adults?: number,
        concessions?: number,
        accompaniedChildren?: number,
        infants?: number,
        nursedInfant?: number,
        seatedInfant?: number,
        concessionCard1?: string,
        concessionCard2?: string,
        requiresSpecialAssistance?: boolean,
        specialAssistanceType?: number,
        concessionLater?: boolean,
        studentCard1?: string,
        studentCard2?: string,
        studentLater?: boolean,
        students?: number
    ) {
        this.adults = adults;
        this.concessions = concessions;
        this.accompaniedChildren = accompaniedChildren;
        this.infants = infants;
        this.nursedInfant = nursedInfant;
        this.seatedInfant = seatedInfant;
        this.concessionCard1 = concessionCard1;
        this.concessionCard2 = concessionCard2;
        this.concessionLater = concessionLater;
        this.studentCard1 = studentCard1;
        this.studentCard2 = studentCard2;
        this.studentLater = studentLater;
        this.students = students;
    }
}
export class UpdatePassengerOption {
    constructor(private passenger: Passenger, private bookingGuid: string) { }
}

export class Passenger {
    Address: string;
    City: string;
    Concession: string;
    Concession2: string;
    Country: string;
    DOB: Date;
    Email: string;
    FemaleCount: number;
    FirstName: string;
    MaleCount: number;
    Phone: string;
    PassengerGuid: string;
    PostCode: string;
    SATypeDescription: string;
    State: string;
    Surname: string;
    Title: string;
    Gender: string;
    PurchaseNumber: number;
    Index: number;
    // added
    fareTypeDescription: string;
    visible: boolean;
    header: string;
    RequiresVisa: boolean;
    VisaNumber: string;
    VisaPromoCode: string;
    constructor() {
        this.Gender = '';
        this.Country = '';
    }

    public isANewPassenger(): boolean {
        return this.Index === 0;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/models/passenger.model.ts